import { createUseStyles } from "react-jss";
import { ASSET_URL } from "../../api";
import userpng from "../../assets/user.png";
import { useQueryGetUserByKeycloakId } from "../../hooks/user/useQueryGetUserByKeycloakId";
import styleVariables from "../../style_setup";

const styles = createUseStyles({
  DropDownProfileOption: {
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    alignItems: "center",
    justifySelf: "center",
    gap: ".5rem",
    padding: "0 .5rem",
    fontSize: "medium",
    fontWeight: "500",
    color: "black",
  },
  avatar: {
    width: "2rem",
    height: "2rem",
    objectFit: "cover",
    borderRadius: "50%",
    marginRight: ".2rem",
  },
  [`@media ${styleVariables.media.smallscreen}`]: {},
});
export const DropDownProfileOption = () => {
  const classes = styles({});

  const { data: user } = useQueryGetUserByKeycloakId();

  return (
    <div className={classes.DropDownProfileOption}>
      <img
        src={user.imageLink ? `${ASSET_URL}/${user.imageLink}` : userpng}
        alt=""
        className={classes.avatar}
      />
      {user?.username || "Profile"}
    </div>
  );
};
